import React, { useState, useEffect } from "react";  
import { Button } from "../../../../components/ui/button";

const HeroImage = "/assets/Hero1.jpg"; // Path relative to the public folder

export const HeroByAnima = (): JSX.Element => {
  // State to store window width for responsive styles
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update the window width when the window is resized
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Set font sizes based on window width (using vw for responsive scaling)
  const getFontSize = () => {
    if (windowWidth < 768) {
      // For mobile screens, use larger viewport width (vw)
      return { h1: "7vw", p: "3vw" };  // Mobile (8vw for title, 4vw for paragraph)
    } else {
      // For desktops and larger monitors, use smaller viewport width (vw)
      return { h1: "3vw", p: "1vw" };  // Desktop and larger monitors (3vw for title, 1vw for paragraph)
    }
  };

  const fontSize = getFontSize();

  return (
    <section
      id="kits-section"
      className="relative min-h-screen flex flex-col items-center justify-center px-6 sm:px-10 md:px-20 lg:px-60 gap-8 w-full max-w-screen overflow-hidden"
      style={{
        background: `linear-gradient(0deg, rgba(18,13,49,0.3) 0%, rgba(18,13,49,0.3) 0%), url(${HeroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Add overlay for the color */}
      <div
        className="absolute inset-0 bg-[#000000] opacity-30"
        style={{ zIndex: 0 }}  // Ensure overlay is below content
      ></div>

      {/* Container to keep content centered */}
      <div className="relative z-10 flex flex-col items-center text-center gap-8 w-full">
        {/* Title */}
        <h1
          className="font-['Plus_Jakarta_Sans',Helvetica] font-bold text-white text-center leading-tight"
          style={{
            fontSize: fontSize.h1,  // Dynamically applied based on screen size
            lineHeight: "1.2",
          }}
        >
          Transform Travel Time into Magic
        </h1>

        {/* Description */}
        <p
          className="font-['Plus_Jakarta_Sans',Helvetica] font-semibold text-white text-base sm:text-lg lg:text-xl leading-relaxed max-w-3xl"
          style={{
            fontSize: fontSize.p,  // Dynamically applied based on screen size
            lineHeight: "1.6",
            padding: "0 15px",
          }}
        >
          Introducing SkyJoy™ and Jai Pavan™ travel kits – where Indian culture meets screen-free entertainment. Crafted for young explorers aged 4–10, our sustainable activity kits make every journey a delightful adventure.
        </p>

        {/* Buttons */}
        <div className="flex items-center gap-3 mt-8">
          <button
            className="w-[200px] gap-3 px-6 py-2 rounded-[40px] border border-solid border-[#003230] font-['Plus_Jakarta_Sans',Helvetica] font-semibold text-white text-base leading-6 transition-all duration-300"
            style={{
              background: 'linear-gradient(to right, #0B7E7A, #003230)',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = 'linear-gradient(to bottom, #16A39C, #004A45)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = 'linear-gradient(to bottom, #0B7E7A, #003230)';
            }}
            aria-label="Scroll to kits section"
            onClick={() => {
              document.getElementById('kits')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Explore Our Kits
          </button>

          <Button
            variant="outline"
            className="w-[200px] gap-3 px-6 py-3 rounded-[40px] border border-solid border-[#003230] bg-transparent font-['Plus_Jakarta_Sans',Helvetica] font-semibold text-white text-base leading-6 hover:bg-[#F5A93E] hover:border-[#F5A93E] hover:text-white transition-colors duration-300"
          >
            Partner With Us
          </Button>
        </div>
      </div>
    </section>
  );
};
